import Reflux from 'reflux';

import debounce from 'lodash/debounce';
import map from 'lodash/map';
import filter from 'lodash/filter';

import {dataUrl} from '../config';

import globalActions from '../actions/global-actions';
import listActions from '../actions/list-actions';
import formStateStore from '../stores/form-state-store';
import {updateStateFromLocation, updateUrl} from '../history';

export default Reflux.createStore({
	init: function () {
		this.listenTo(formStateStore, this.onFormStateChange);
		this.listenToMany(globalActions);
		this._state = {data: {}, filter: null, url: dataUrl};

		this.onFormStateChange = debounce(this.onFormStateChange, 700, {
			maxWait: 5000,
		});
	},

	_mapFeatureToStand: function (feature) {
		return Object.assign(
			{id: feature.id, geometry: feature.geometry},
			feature.properties
		);
	},

	_filterStandByFilter: function (stand) {
		const filterOkay =
			!this._state.filter || this._state.filter.indexOf(stand.id) > -1;
		const additionalFilterOkay =
			!this._state.additionalFilter ||
			this._state.additionalFilter.indexOf(stand.id) > -1;

		return filterOkay && additionalFilterOkay;
	},

	_filterStandBySearchTerm: function (stand, searchTerm) {
		return (
			(stand.name && stand.name.toLowerCase().indexOf(searchTerm) > -1) ||
			(stand.description &&
				stand.description.toLowerCase().indexOf(searchTerm) > -1)
		);
	},

	output: function () {
		const searchTerm =
			this._state.searchTerm && this._state.searchTerm.length > 2
				? this._state.searchTerm.trim().toLowerCase()
				: null;

		const staende = map(this._state.data.features, (feature) =>
			this._mapFeatureToStand(feature)
		);
		const filteredStaende = filter(
			staende,
			searchTerm
				? (stand) =>
						this._filterStandByFilter(stand) &&
						this._filterStandBySearchTerm(stand, searchTerm)
				: (stand) => this._filterStandByFilter(stand)
		);

		const categoryFilters = this._state.data.categoryFilters || {};
		const additionalCategoryFilters =
			this._state.data.additionalCategoryFilters || {};
		const categoryColorMap = this._state.data.categoryColorMap || {};

		this.trigger({
			categoryFilters: categoryFilters,
			additionalCategoryFilters: additionalCategoryFilters,
			categoryColorMap: categoryColorMap,
			geojson: this._state.data,
			filter: this._state.filter,
			additionalFilter: this._state.additionalFilter,
			searchTerm: this._state.searchTerm,
			staende: staende,
			filteredStaende: filteredStaende,
			searchResultStaende: map(filteredStaende, 'id'),
		});
	},

	onFormStateChange: function (state) {
		this._state.filter =
			state.selectedFilterOption &&
			JSON.parse(state.selectedFilterOption);
		this._state.additionalFilter =
			state.selectedAdditionalFilterOption &&
			JSON.parse(state.selectedAdditionalFilterOption);
		this._state.searchTerm = state.searchTerm;
		this.output();
	},

	onSync: function () {
		fetch(this._state.url)
			.then((response) => response.json())
			.then((data) => {
				this.onSyncCompleted(data);
			})
			.catch((error) => {
				this.onSyncFailed(error);
			});
	},

	onSyncCompleted: function (data) {
		this._state.data = data;
		this.output();

		const hash = (
			window.parent?.location.hash || window.location.hash
		).replace(/^#/, '');
		if (hash && hash !== '') {
			globalActions.selectStand(hash);
			listActions.showDetails(hash);
			updateUrl(hash);
		} else {
			updateStateFromLocation(
				window.parent?.document.location || document.location
			);
		}
	},

	onSyncFailed: function () {
		console.error('onSyncFailed');
	},

	getInitialState: function () {
		return {data: {}, filter: null, additionalFilter: null};
	},
});
